import { Routes } from '@angular/router';
import { ROUTES } from './core/constants/routes';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: ROUTES.HOME,
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: ROUTES.ABOUT,
        loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent),
      },
      {
        path: ROUTES.CONTACT,
        loadComponent: () =>
          import('./pages/contact/contact.component').then(m => m.ContactComponent),
      },
      {
        path: ROUTES.ROLE_SELECTION,
        loadComponent: () =>
          import('./pages/role-selection/role-selection.component').then(
            m => m.RoleSelectionComponent,
          ),
      },
      {
        path: ROUTES.DRIVER,
        loadComponent: () => import('./pages/driver/driver.component').then(m => m.DriverComponent),
      },
      {
        path: ROUTES.CONTRACTOR,
        loadComponent: () =>
          import('./pages/contractor/contractor.component').then(m => m.ContractorComponent),
      },
      {
        path: 'admin',
        redirectTo: 'https://app.dirtrunner.pro/auth/login',
        pathMatch: 'full',
      },
      {
        path: ROUTES.TERMS,
        loadComponent: () => import('./pages/terms/terms.component').then(m => m.TermsComponent),
      },
      {
        path: ROUTES.PRIVACY,
        loadComponent: () =>
          import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
      },
      {
        path: ROUTES.EULA,
        loadComponent: () => import('./pages/eula/eula.component').then(m => m.EulaComponent),
      },
      {
        path: ROUTES.NOT_FOUND,
        loadComponent: () =>
          import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
      },
    ],
  },
];
